'use client'
import { useState, useEffect } from "react";

const getDeviceType = (width) => {
    if (width < 768) return "mobile";
    if (width >= 768 && width <= 1024) return "tablet";
    return "laptop";
};

const useDeviceType = () => {
    const [deviceType, setDeviceType] = useState(() => {
        if (typeof window !== "undefined") {
            return getDeviceType(window.innerWidth);
        }
        return "laptop"; // Default for SSR
    });

    useEffect(() => {
        if (typeof window === "undefined") return;

        let timeoutId

        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setDeviceType(getDeviceType(window.innerWidth));
            }, 150); // Debounce delay
        };

        window.addEventListener("resize", handleResize);

        // Trigger once on mount
        handleResize();

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return deviceType;
};

export default useDeviceType;
